import { ButtonHTMLAttributes } from 'react';

import * as styles from './button.module.scss';

export enum ButtonSize {
    Small = 'small',
    Medium = 'medium',
    Big = 'big'
}

export enum ButtonVariant {
    Normal = 'normal',
    Outline = 'outline',
    Disabled = 'disabled'
}

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    id?: string;
    size?: ButtonSize;
    variant?: ButtonVariant;
    fullWidth?: boolean;
    style?: Object;
    resize?: boolean;
    text: string;
}

export const Button = (props: Props) => {
    const {
        size = ButtonSize.Big,
        variant = ButtonVariant.Normal,
        fullWidth = false,
        resize = false,
        style,
        ...rest
    } = props;
    return (
        <button
            {...rest}
            className={`${styles.button} ${styles[variant]} ${styles[size]} ${fullWidth ? styles.fullWidth : ''}`}
            style={style}>
            {props.text}
        </button>
    );
};
